import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './Babita.css';

const ROMANTIC_QUOTES = [
  "You are my today and all of my tomorrows.",
  "Every moment with you is a gift.",
  "I fell in love with you because of the million tiny things you do.",
  "You are the best thing that ever happened to me.",
];

const Babita = () => {
  const [saidYes, setSaidYes] = useState(false);
  const [noClicks, setNoClicks] = useState(0);
  const [noPosition, setNoPosition] = useState({ x: 0, y: 0 });

  const handleYes = () => setSaidYes(true);

  const handleNoHover = () => {
    setNoClicks((c) => c + 1);
    setNoPosition({
      x: (Math.random() - 0.5) * 120,
      y: (Math.random() - 0.5) * 80,
    });
  };

  const confettiPieces = useMemo(() => {
    return Array.from({ length: 80 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.8,
      duration: 2 + Math.random() * 1.5,
      color: ['#ff6b9d', '#c44569', '#ffa07a', '#ff69b4', '#ff1493', '#ffb6c1', '#ffc0cb', '#e91e63'][Math.floor(Math.random() * 8)],
      size: 6 + Math.random() * 8,
      rotation: Math.random() * 360,
    }));
  }, []);

  return (
    <div className="babita-page">
      <div className="babita-bg-hearts" aria-hidden="true">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className="bg-heart" style={{ '--i': i, '--x': Math.random() * 100, '--d': 3 + Math.random() * 4 }}>♥</div>
        ))}
      </div>

      {saidYes && (
        <>
          <div className="babita-confetti" aria-hidden="true">
            {confettiPieces.map((p) => (
              <div
                key={p.id}
                className="confetti-piece"
                style={{
                  left: `${p.left}%`,
                  animationDelay: `${p.delay}s`,
                  animationDuration: `${p.duration}s`,
                  backgroundColor: p.color,
                  width: p.size,
                  height: p.size,
                  transform: `rotate(${p.rotation}deg)`,
                }}
              />
            ))}
          </div>
          <div className="babita-hearts-burst" aria-hidden="true">
            {Array.from({ length: 24 }).map((_, i) => (
              <span key={i} className="heart-burst" style={{ '--i': i }}>♥</span>
            ))}
          </div>
        </>
      )}

      <div className="babita-container">
        {!saidYes ? (
          <>
            <p className="babita-prompt">Babita,</p>
            <h1 className="babita-title">Will you be my Valentine?</h1>
            <p className="babita-sub">I would be the luckiest person if you said yes 💕</p>

            <div className="babita-buttons">
              <button
                type="button"
                className="babita-btn babita-btn-yes"
                onClick={handleYes}
                aria-label="Say yes"
              >
                Yes, always!
              </button>
              <button
                type="button"
                className="babita-btn babita-btn-no"
                onMouseEnter={noClicks < 6 ? handleNoHover : undefined}
                onClick={noClicks >= 6 ? handleYes : undefined}
                style={{
                  transform: `translate(${noPosition.x}px, ${noPosition.y}px)`,
                }}
                aria-label={noClicks >= 6 ? 'Say yes' : 'Say no'}
              >
                {noClicks >= 6 ? 'Yes is right here 💕' : 'No'}
              </button>
            </div>

            {noClicks >= 3 && noClicks < 6 && (
              <p className="babita-hint">The Yes button is waiting for you 😊</p>
            )}
          </>
        ) : (
          <div className="babita-success">
            <div className="babita-success-badge">She said yes!</div>
            <h2 className="babita-success-title">You just made my day — and my year.</h2>
            <p className="babita-success-quote">
              "{ROMANTIC_QUOTES[Math.floor(Math.random() * ROMANTIC_QUOTES.length)]}"
            </p>
            <div className="babita-reasons">
              <h3>A few reasons I love you</h3>
              <ul>
                <li>Your smile</li>
                <li>How you make ordinary moments special</li>
                <li>Your kindness</li>
                <li>Every conversation with you</li>
                <li>That you said yes today</li>
              </ul>
            </div>
            <p className="babita-signature">— With all my love, Manish</p>
            <Link to="/" className="babita-back">Back to portfolio</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Babita;
